import { saveDataUrl } from "./save-file";

export const downloadDiagram = (content: string, name: string): void => {
  void saveDataUrl(content, name);
};
